import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Router } from 'react-router-dom';
import { intercept } from 'common/axios/interseptor';
import { App } from 'App';
import { history } from 'common/utils';
import { notification } from 'components/layout/Notification/Notification';
import { ApiError } from 'api';
import { YaMetrics } from 'components/layout/YaMetrics/YaMetrika';
import ErrorBoundary from 'components/pages/ErrorBoundary/ErrorBoundary';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: error => {
        const e = error as ApiError;
        if (e?.message) {
          notification({ type: 'error', message: e.message });
        }
      },
      retry: 0,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: error => {
        const e = error as ApiError;
        if (e?.message) {
          notification({ type: 'error', message: e.message });
        }
      },
      retry: 0,
    },
  },
});

// ИнитАксиоса
intercept();

ReactDOM.render(
  <>
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Router>
      <ReactQueryDevtools position='bottom-right' />
    </QueryClientProvider>

    <YaMetrics />
  </>,
  document.getElementById('root') || document.createElement('div'),
);
